var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.label)?_c('v-chip',{staticClass:"cedido-label",attrs:{"x-small":"","label":"","color":"teal lighten-5","text-color":"teal darken-3"}},[_c('v-icon',{attrs:{"x-small":"","left":""}},[_vm._v("mdi-car-key")]),_vm._v(" "+_vm._s(_vm.label)+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }